<template>
<footer class="footer">
  <div class="footer-content">
    <div class="footer-container">
      <div class="footer-brand">
        <div class="footer-logo">
          <span class="logo-icon">🌿</span>
          <span class="logo-text">GBWhatsApp</span>
        </div>
        <p class="footer-tagline">{{ t.tagline }}</p>
      </div>

      <nav class="footer-menu">
        <div class="footer-menu-section">
          <span class="footer-menu-title">{{ t.legalTitle }}</span>
          <div class="footer-links">
            <router-link
              v-for="item in legalLinks"
              :key="item.path"
              :to="item.path"
              class="footer-link"
            >{{ item.label }}</router-link>
          </div>
        </div>
      </nav>

      <div class="footer-note">
        <p>© {{ copyrightYear }} <router-link :to="localeHomePath" class="footer-link">gbwaap.com</router-link> {{ t.rights }}</p>
      </div>
    </div>
  </div>
</footer>
</template>

<script>
import footerLocales from '@/i18n/footer.js';

export default {
  name: 'Footer',
  computed: {
    /** 与首页、顶栏一致：由路由 name 推断语言 */
    locale() {
      const name = this.$route?.name || '';
      const lang = name.split('-')[0];
      return ['en', 'es', 'hi', 'pt', 'id'].includes(lang) ? lang : 'en';
    },
    localeHomePath() {
      const paths = { en: '/', hi: '/in/', es: '/es/', pt: '/pt/', id: '/id/' };
      return paths[this.locale] || '/';
    },
    t() {
      return footerLocales[this.locale] || footerLocales.en;
    },
    copyrightYear() {
      return new Date().getFullYear();
    },
    legalLinks() {
      return [
        { label: this.t.contact, path: '/contact/' },
        { label: this.t.privacy, path: '/privacy/' },
        { label: this.t.terms, path: '/terms-of-service/' },
        { label: this.t.dmca, path: '/dmca/' },
        { label: this.t.disclaimer, path: '/disclaimer/' },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
/* 字体在 public/index 与 index.temp.html 中统一加载 */

.footer {
  position: relative;
  background: linear-gradient(180deg, #f7f5f0 0%, #ebe7df 100%);
  margin-top: 60px;
}


.footer-content {
  background: linear-gradient(135deg, #2d5a27 0%, #4a7c43 100%);
  padding: 50px 0 30px;
  border-radius: 40px 40px 0 0;
}

.footer-container {
  width: 1080px;
  max-width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.footer-brand {
  text-align: center;
}

.footer-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 8px;

  .logo-icon {
    font-size: 28px;
    animation: leafFloat 3s ease-in-out infinite;
  }

  .logo-text {
    font-family: 'Outfit', sans-serif;
    font-size: 24px;
    font-weight: 700;
    color: #fff;
    letter-spacing: -0.5px;
  }
}

@keyframes leafFloat {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-4px) rotate(5deg); }
}

.footer-tagline {
  font-family: 'DM Sans', sans-serif;
  color: rgba(255, 255, 255, 0.75);
  font-size: 14px;
  margin: 0;
}

.footer-menu {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 32px 48px;
  width: 100%;
  max-width: 900px;
}

.footer-menu-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.footer-menu-title {
  font-family: 'Outfit', sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.footer-links {
  display: flex;
  align-items: center;
  gap: 10px 16px;
  flex-wrap: wrap;
  justify-content: center;
}

.footer-link {
  font-family: 'DM Sans', sans-serif;
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 8px;
  transition: all 0.25s ease;

  &:hover {
    color: #fff;
    background: rgba(255, 255, 255, 0.15);
    transform: translateY(-2px);
  }

  &.router-link-active {
    color: #fff;
    background: rgba(255, 255, 255, 0.2);
  }
}

.link-divider {
  color: rgba(255, 255, 255, 0.4);
  font-size: 12px;
}

.footer-note {
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  text-align: center;

  p {
    margin: 0;
  }

  .footer-link {
    padding: 0;
    font-weight: 600;

    &:hover {
      background: transparent;
      text-decoration: underline;
    }
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer-content {
    padding: 40px 0 25px;
    border-radius: 30px 30px 0 0;
  }

  .footer-menu {
    flex-direction: column;
    gap: 24px;
  }

  .footer-menu-section {
    width: 100%;
  }

  .footer-links {
    gap: 8px;
  }

  .footer-logo {
    .logo-icon {
      font-size: 24px;
    }

    .logo-text {
      font-size: 20px;
    }
  }
}
</style>
